<template>
  <div>
    <section class="cart-lists">
      <div
        class="cart-lists-top p-3 d-flex border-bottom justify-content-between"
      >
        <div class="d-flex align-items-center">
          <svg
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.2659 15.4919H7.01918C6.15962 15.4919 5.3348 15.1272 4.75308 14.4934C4.17137 13.8596 3.87617 13.0087 3.94563 12.1492L4.66627 3.50157C4.69231 3.23242 4.5968 2.97195 4.41447 2.77226C4.23214 2.57256 3.98036 2.46837 3.7112 2.46837H2.20916C1.85318 2.46837 1.55798 2.17317 1.55798 1.81719C1.55798 1.46122 1.85318 1.16602 2.20916 1.16602H3.71989C4.35371 1.16602 4.95278 1.43517 5.37821 1.89533C5.61264 2.1558 5.78629 2.45969 5.88179 2.7983H16.7261C17.603 2.7983 18.4104 3.14559 19.0008 3.77072C19.5825 4.40453 19.8778 5.22936 19.8083 6.10628L19.3394 12.618C19.2439 14.2069 17.8548 15.4919 16.2659 15.4919ZM5.92521 4.09196L5.24798 12.2534C5.20457 12.7569 5.36953 13.2345 5.70815 13.6078C6.04676 13.9812 6.5156 14.1809 7.01918 14.1809H16.2659C17.1689 14.1809 17.985 13.4168 18.0545 12.5139L18.5233 6.00209C18.558 5.48983 18.3931 5.00362 18.0545 4.64765C17.7158 4.28299 17.247 4.08327 16.7347 4.08327H5.92521V4.09196Z"
              fill="#105730"
            />
            <path
              d="M14.5814 19.8333C13.6264 19.8333 12.845 19.0519 12.845 18.0968C12.845 17.1418 13.6264 16.3604 14.5814 16.3604C15.5365 16.3604 16.3179 17.1418 16.3179 18.0968C16.3179 19.0519 15.5365 19.8333 14.5814 19.8333ZM14.5814 17.6627C14.3383 17.6627 14.1473 17.8537 14.1473 18.0968C14.1473 18.3399 14.3383 18.5309 14.5814 18.5309C14.8245 18.5309 15.0156 18.3399 15.0156 18.0968C15.0156 17.8537 14.8245 17.6627 14.5814 17.6627Z"
              fill="#105730"
            />
            <path
              d="M7.63564 19.8333C6.68058 19.8333 5.89917 19.0519 5.89917 18.0968C5.89917 17.1418 6.68058 16.3604 7.63564 16.3604C8.5907 16.3604 9.37211 17.1418 9.37211 18.0968C9.37211 19.0519 8.5907 19.8333 7.63564 19.8333ZM7.63564 17.6627C7.39253 17.6627 7.20152 17.8537 7.20152 18.0968C7.20152 18.3399 7.39253 18.5309 7.63564 18.5309C7.87875 18.5309 8.06976 18.3399 8.06976 18.0968C8.06976 17.8537 7.87875 17.6627 7.63564 17.6627Z"
              fill="#105730"
            />
            <path
              d="M18.7056 7.67833H8.2868C7.93082 7.67833 7.63562 7.38313 7.63562 7.02715C7.63562 6.67118 7.93082 6.37598 8.2868 6.37598H18.7056C19.0616 6.37598 19.3568 6.67118 19.3568 7.02715C19.3568 7.38313 19.0616 7.67833 18.7056 7.67833Z"
              fill="#105730"
            />
          </svg>
          <span
            class="text-color-theme rounded-circle weight-bold fontsize-large mr-1 pt-1"
            ><span class="">{{
              cart != null && cart.cartItems != null ? quantity : 0
            }}</span>
            مورد</span
          >
        </div>
        <button
          type="button"
          class="cart-lists-btn bg-none"
          @click="cartListsClose()"
        >
          <span class="font-weight-bold">
            <CloseSvg width="24" />
          </span>
        </button>
      </div>
      <div class="cart-lists-content">
        <ul
          v-if="cart != null && cart.cartItems != null && cart.cartItems != ''"
        >
          <li
            class="cart-lists-item"
            v-for="(cartItem, index) in cart.cartItems"
            :key="index"
          >
            <CartListItem v-model="cart.cartItems[index]" :index="index" />
          </li>
        </ul>
        <div v-else class="text-center mt-5">
          <svg
            width="50"
            height="50"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.9303 7C16.9621 6.92913 16.977 6.85189 16.9739 6.77432H17C16.8882 4.10591 14.6849 2 12.0049 2C9.325 2 7.12172 4.10591 7.00989 6.77432C6.9967 6.84898 6.9967 6.92535 7.00989 7H6.93171C5.65022 7 4.28034 7.84597 3.88264 10.1201L3.1049 16.3147C2.46858 20.8629 4.81062 22 7.86853 22H16.1585C19.2075 22 21.4789 20.3535 20.9133 16.3147L20.1444 10.1201C19.676 7.90964 18.3503 7 17.0865 7H16.9303ZM15.4932 7C15.4654 6.92794 15.4506 6.85153 15.4497 6.77432C15.4497 4.85682 13.8899 3.30238 11.9657 3.30238C10.0416 3.30238 8.48184 4.85682 8.48184 6.77432C8.49502 6.84898 8.49502 6.92535 8.48184 7H15.4932ZM9.097 12.1486C8.60889 12.1486 8.21321 11.7413 8.21321 11.2389C8.21321 10.7366 8.60889 10.3293 9.097 10.3293C9.5851 10.3293 9.98079 10.7366 9.98079 11.2389C9.98079 11.7413 9.5851 12.1486 9.097 12.1486ZM14.002 11.2389C14.002 11.7413 14.3977 12.1486 14.8858 12.1486C15.3739 12.1486 15.7696 11.7413 15.7696 11.2389C15.7696 10.7366 15.3739 10.3293 14.8858 10.3293C14.3977 10.3293 14.002 10.7366 14.002 11.2389Z"
              fill="#999"
            />
          </svg>
          <h5 class="text-color-999 pt-3 fontsize-heavy">
            سبد خرید شما خالی می باشد.
          </h5>
        </div>
      </div>
      <div class="cart-lists-bottom p-3 bg-color-f1">
        <div class="bg-transparent border p-3 mb-2 border-r-13">
          <div
            class="d-flex justify-content-between fontsize-small text-color-444 mb-2"
          >
            <div class="font-weight-bold">تخفیف کل</div>
            <div>
              <span v-if="totalSaving != 0" class="font-weight-bold">{{
                totalSaving | price
              }}</span>
              <span v-else class="font-weight-bold">0</span>
              <span class="font-weight-bold pr-1">تومان</span>
            </div>
          </div>
          <div class="d-flex justify-content-between text-color-theme">
            <div class="weight-bold fontsize-large">مجموع</div>
            <div>
              <span v-if="totalPrice != 0" class="weight-bold fontsize-large"
                >{{ totalPrice | price }}
              </span>
              <span v-else class="weight-bold">0 </span>
              <span class="weight-bold">تومان</span>
            </div>
          </div>
        </div>

        <router-link
          id="seeCardLink"
          @click.native="continueCartClicked"
          to="/cart"
          :disabled="totalPrice == 0 || disabled"
          class="custom-btn w-100"
          >مشاهده سبد خرید</router-link
        >
      </div>
    </section>
    <div class="cart-lists-close-resp" @click="cartListsClose()"></div>
    <!-- close cartLists by click to body-->
  </div>
</template>

<script>
import { cartListsOpen } from "@/libraries/functions";

import CartListItem from "@/parts/Front/components/cart/CartListItem";
import CloseSvg from "@/components/svgs/CloseSvg";
export default {
  name: "CartLists",
  components: {
    CloseSvg,
    CartListItem,
  },
  data() {
    return {
      disabled: false,
    };
  },
  watch: {
    "$route.path"() {
      this.cartListsClose();
    },
  },
  computed: {
    cart() {
      if (
        this.$store.getters["front/getHomeData"] != null &&
        this.$store.getters["front/getHomeData"].user.cart.cartItems != null
      ) {
        return this.$store.getters["front/getHomeData"].user.cart;
      } else {
        return null;
      }
    },
    totalSaving() {
      return this.cart ? this.cart.getTotalSaving() : 0;
    },
    totalPrice() {
      return this.cart ? this.cart.getTotalPrice() : 0;
    },
    quantity() {
      if (this.cart) {
        return this.cart.cartItems.reduce((sum, item) => {
          sum += item.quantity;
          return sum;
        }, 0);
      } else {
        return 0;
      }
    },
  },
  mounted() {
    if (this.$route.fullPath.includes("#cart-modal")) {
      // this.$router.replace(this.$route.fullPath.replace("#cart-modal", ""));
      cartListsOpen();
    }
    this.$nextTick(() => {
      this.checkIosConfig();
    });
    window.removeEventListener("popstate", this.checkBackButton);
    window.addEventListener("popstate", this.checkBackButton);
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.checkBackButton);
  },
  methods: {
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "other";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "Ios";
      }

      return "other";
    },
    checkIosConfig() {
      if (this.getMobileOperatingSystem() == "Ios") {
        document.getElementById("seeCardLink").style.marginBottom = "10px";
      }
    },
    cartListsClose() {
      // عین همین کد توی ی کومپوننت دیگه هست
      let cartLists = document.getElementsByClassName("cart-lists")[0];
      const cartListsCloseResp = document.getElementsByClassName(
        "cart-lists-close-resp"
      )[0];
      cartListsCloseResp.style.display = "none";
      cartLists.style.left = "-500px";
      this.$router
        .replace(this.$route.fullPath.replace("#cart-modal", ""))
        .catch((e) => {});
    },
    checkBackButton() {
      if (!this.$route.fullPath.includes("#cart-modal")) {
        this.cartListsClose();
      }
    },
    continueCartClicked() {
      if (this.$route.path === "/cart") {
        this.cartListsClose();
      }
    },
    // negCounter(){
    //   if (this.counter > 0){
    //     this.counter -- ;
    //   }
    // }
  },
};
</script>

<style scoped>
.cart-lists-content {
  scrollbar-color: var(--color-theme) var(--color-theme2);
  scrollbar-width: thin;
}
.cart-lists .prosecced-checkout {
  font-size: 16px !important;
}
</style>
